// // import { useState, useContext, useEffect, useRef } from "react";
// // import { Navigate, useNavigate } from "react-router-dom";
// // import { Button, Box, Container, Typography } from "@mui/material";
// // import { makeStyles } from "@mui/styles";
// // import ClipLoader from "react-spinners/ClipLoader";
// // import { toast } from "react-toastify";

// // import Select from "../components/Select";
// // import userContext from "../context/userContext";
// // import apiClient from "../api/apiServices";
// // import { convertArrOfStringsToString } from "../utils/stringUtils";

// // const templateImages = {
// //   // TODO: get this dynamically from the backend as well
// //   urdu: `/static/Urdu - Template.jpg`,
// // };

// // const NewUpload = () => {
// //   const classes = useStyles();
// //   const navigate = useNavigate();
// //   const { user, backendConfig, appSettings } = useContext(userContext);

// //   const fileInputRef = useRef();

// //   const [filename, setFilename] = useState(null);
// //   const [file, setFile] = useState(null);
// //   const [filepath, setFilepath] = useState(null);
// //   const [fileExtension, setFileExtension] = useState(null);
// //   const [fileObjectUrl, setFileObjectUrl] = useState(null);
// //   const [isUploading, setIsUploading] = useState(false);

// //   const [isLoadingAvailableCredits, setIsLoadingAvailableCredits] = useState(false);
// //   const [pagesRemaining, setPagesRemaining] = useState(null);

// //   const [availableTextRecognizers, setAvailableTextRecognizers] = useState([]);
// //   const [availableTextRecognizersNames, setAvailableTextRecognizersNames] = useState([]);
// //   const [selectedTextRecognizerName, setSelectedTextRecognizerName] = useState("");

// //   const [availableDocumentParsers, setAvailableDocumentParsers] = useState([]);
// //   const [supportedDocumentParsersNames, setSupportedDocumentParsersNames] = useState([]);
// //   const [selectedDocumentParserName, setSelectedDocumentParserName] = useState("");

// //   const [isTemplateImageLoaded, setIsTemplateImageLoaded] = useState(false);

// //   const [processingStatus, setProcessingStatus] = useState("Uploading...");

// //   const getAvailableCreditsFromApi = async () => {
// //     setIsLoadingAvailableCredits(true);

// //     const response = await apiClient.user.getAvailableCredits();
// //     if (!response.success) {
// //       console.log(response);
// //       setIsLoadingAvailableCredits(false);
// //       return;
// //     }

// //     setPagesRemaining(Math.floor(response.result.credits));
// //     setIsLoadingAvailableCredits(false);
// //   };

// //   const handleFileUpload = (event, drop = false) => {
// //     let uploadedFile;
// //     if (drop) {
// //       event.preventDefault();
// //       uploadedFile = event.dataTransfer.files[0];
// //     } else {
// //       uploadedFile = event.target.files[0];
// //     }

// //     if (!uploadedFile) {
// //       return;
// //     }

// //     if (!acceptedFileTypes.includes(uploadedFile.type)) {
// //       toast(`Accepted file types are: ${convertArrOfStringsToString(acceptedFileTypes)}.`);
// //       return;
// //     }

// //     if (uploadedFile.size > fileSizeLimitInMB * 1024 * 1024) {
// //       toast(`File cannot be larger than ${fileSizeLimitInMB} MB.`);
// //       return;
// //     }

// //     setFilename(uploadedFile.name);
// //     setFileExtension(uploadedFile.name.split(".").pop());
// //     setFilepath(uploadedFile);
// //     const reader = new FileReader();
// //     reader.onload = (e) => {
// //       const fileData = e.target.result;
// //       setFileObjectUrl(URL.createObjectURL(uploadedFile));
// //       setFile(fileData);
// //     };
// //     reader.readAsDataURL(uploadedFile);
// //   };

// //   const goButtonOnClick = async () => {
// //     setIsUploading(true);

// //     const selectedTextRecognizer = availableTextRecognizers.find(
// //       (textRecognizer) => textRecognizer.displayName === selectedTextRecognizerName
// //     );
// //     const selectedDocumentParser = availableDocumentParsers.find(
// //       (documentParser) => documentParser.displayName === selectedDocumentParserName
// //     );

// //     const response = await apiClient.uploads.addNew(
// //       filepath,
// //       selectedDocumentParser.modelId,
// //       "no_postprocessor",
// //       selectedTextRecognizer.modelId
// //     );

// //     if (!response.success) {
// //       console.log(response);
// //       toast(response.error.message);
// //       setIsUploading(false);
// //       return;
// //     }

// //     setPagesRemaining(pagesRemaining - 1);
// //     setIsUploading(false);

// //     if (appSettings.redirectToHistoryPageOnNewUploadSubmit) {
// //       navigate("/history/1");
// //     } else {
// //       toast("Queued for processing. Please check the history page for status.");
// //     }
// //   };

// //   // const handleLoadTemplateImageButtonClick = (event) => {
// //   //   setFilepath(templateImages[convert_label_to_key(selectedLanguageAndVersion)]);
// //   //   setFile(templateImages[convert_label_to_key(selectedLanguageAndVersion)]);
// //   //   setFilename(templateImages[convert_label_to_key(selectedLanguageAndVersion)].slice(8));
// //   //   setIsTemplateImageLoaded(true);
// //   // };

// //   useEffect(() => {
// //     document.title = "Upload New";

// //     getAvailableCreditsFromApi();
// //   }, []);

// //   useEffect(() => {
// //     if (!backendConfig?.text_recognizers || !backendConfig?.document_parsers) {
// //       return;
// //     }

// //     const textRecognizersNames = backendConfig.text_recognizers.map((textRecognizer) => textRecognizer.displayName);

// //     setAvailableTextRecognizers(backendConfig.text_recognizers);
// //     setAvailableTextRecognizersNames(textRecognizersNames);
// //     setAvailableDocumentParsers(backendConfig.document_parsers);
// //   }, [backendConfig]);

// //   useEffect(() => {
// //     if (!selectedTextRecognizerName) {
// //       setSupportedDocumentParsersNames([]);
// //       return;
// //     }

// //     const selectedTextRecognizer = availableTextRecognizers.find(
// //       (textRecognizer) => textRecognizer.displayName === selectedTextRecognizerName
// //     );

// //     const requiredDetectionLevel = selectedTextRecognizer.detectionLevel[0];
// //     const documentParsersWithRequiredDetectionLevel = availableDocumentParsers.filter(
// //       (documentParser) => documentParser.detectionLevel.includes(requiredDetectionLevel)
// //     );
// //     const documentParsersWithRequiredDetectionLevelNames = documentParsersWithRequiredDetectionLevel.map(
// //       (documentParser) => documentParser.displayName
// //     );

// //     setSupportedDocumentParsersNames(documentParsersWithRequiredDetectionLevelNames);

// //     // TODO: update template image
// //   }, [selectedTextRecognizerName]);

// //   if (user === null) {
// //     return navigate("/auth/login");
// //   }

// //   if (!user.canCompute) {
// //     return (
// //       <div className={classes.pageContainer}>
// //         <Container maxWidth="lg" className={classes.container}>
// //           <Typography variant="h5" color="error">
// //             You do not have compute permission. Please contact an admin for more details.
// //           </Typography>
// //         </Container>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className={classes.pageContainer}>
// //       <div className={classes.container}>
// //         <Box width="100%" display="flex" flexDirection="column" justifyContent="flex-start" alignItems="center" mb={2}>
// //           <Typography className={classes.heading} variant="h3" style={{ fontWeight: "bold", textAlign: "center" }}>
// //             Upload a New File for OCR
// //           </Typography>
// //         </Box>

// //         <Box mb={2}>
// //           {file ? (
// //             fileExtension === "pdf" ? (
// //               <object
// //                 data={file}
// //                 type="application/pdf"
// //                 width={400}
// //                 height={400}
// //                 // onDrop={(e) => handleFileUpload(e, true)}
// //               >
// //                 <Button
// //                   color="primary"
// //                   variant="outlined"
// //                   sx={{ minWidth: 300 }}
// //                   onClick={() => window.open(fileObjectUrl, "_blank")}
// //                 >
// //                   {`File Loaded: ${filename}`}
// //                 </Button>
// //               </object>
// //             ) : (
// //               <img
// //                 style={{
// //                   display: "block",
// //                   maxWidth: "50vw",
// //                   maxHeight: "50vh",
// //                   width: "auto",
// //                   height: "auto",
// //                   marginBottom: "5vh",
// //                   border: "1px solid black",
// //                 }}
// //                 src={file}
// //                 alt="uploaded image"
// //                 onDrop={(e) => handleFileUpload(e, true)}
// //                 onDragOver={(e) => e.preventDefault()}
// //               />
// //             )
// //           ) : (
// //             <div
// //               onDrop={(e) => handleFileUpload(e, true)}
// //               onDragOver={(e) => e.preventDefault()}
// //               style={{
// //                 width: "50vw",
// //                 height: "50vh",
// //                 border: "1px dashed black",
// //                 backgroundImage: "linear-gradient(#fae8e1,#f9e4dd)",
// //                 borderRadius: 25,
// //                 display: "flex",
// //                 flexDirection: "column",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //               }}
// //             >
// //               Drag and drop file here
// //             </div>
// //           )}
// //         </Box>

// //         <Box width="50%" display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center" mb={2}>
// //           <Box>
// //             <input
// //               id="image-upload-input"
// //               type="file"
// //               accept=".jpg,.jpeg,.pdf"
// //               onChange={handleFileUpload}
// //               style={{ display: "none" }}
// //               ref={fileInputRef}
// //             />
// //             <label
// //               for="image-upload-input"
// //               style={{
// //                 backgroundImage: "linear-gradient(#fae8e1,#f9e4dd)",
// //                 border: "1px dashed black",
// //                 padding: 10,
// //                 borderRadius: 5,
// //                 marginBottom: 15,
// //               }}
// //             >
// //               {isTemplateImageLoaded ? "Choose Another File" : filename ? filename : "Choose File"}
// //             </label>
// //           </Box>

// //           {/* {appSettings.showTemplateImagesOnNewUploadPage &&
// //           Object.keys(templateImages).includes(convert_label_to_key(selectedLanguageAndVersion)) ? (
// //             <Button color="primary" variant="outlined" onClick={handleLoadTemplateImageButtonClick}>
// //               Load Template Image
// //             </Button>
// //           ) : null} */}
// //         </Box>

// //         <Box width="50%" display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center" mb={2}>
// //           <Box width="30%">
// //             <Select
// //               placeholder="Select Language"
// //               selectedValue={selectedTextRecognizerName}
// //               setSelectedValue={(newValue) => {
// //                 setSelectedTextRecognizerName(newValue);
// //               }}
// //               allValues={availableTextRecognizersNames}
// //             />
// //           </Box>

// //           <Box width="30%">
// //             <Select
// //               placeholder="Select Parser"
// //               selectedValue={selectedDocumentParserName}
// //               setSelectedValue={(newValue) => {
// //                 setSelectedDocumentParserName(newValue);
// //               }}
// //               allValues={supportedDocumentParsersNames}
// //               disabled={!selectedTextRecognizerName}
// //             />
// //           </Box>
// //         </Box>

// //         <Box mb={2}>
// //           {isUploading ? (
// //             <ClipLoader color={"#0000EE"} loading={true} size={35} />
// //           ) : (
// //             <Button
// //               variant="contained"
// //               size="large"
// //               disabled={file === null || !selectedTextRecognizerName || !selectedDocumentParserName}
// //               onClick={goButtonOnClick}
// //             >
// //               Start OCR !
// //             </Button>
// //           )}
// //         </Box>

// //       <Box mb={2}>
// //       {isUploading ? (
// //        <Typography variant="h6">{processingStatus}</Typography>
// //        ) : !isLoadingAvailableCredits && pagesRemaining ? (
// //        <Typography variant="h6" color={pagesRemaining <= 10 ? "error" : "primary"}>
// //        {`You can OCR ${pagesRemaining} more ${pagesRemaining === 1 ? "page" : "pages"}.`}
// //        </Typography>
// //        ) : !isLoadingAvailableCredits && pagesRemaining === null ? (
// //        <Typography variant="h6" color="error">
// //         Unable to retrieve the available pages quota from the server.
// //        </Typography>
// //        ) : null}
// //         </Box>
// //       </div>
// //     </div>
// //   );
// // };

// // export default NewUpload;

// // const useStyles = makeStyles((theme) => ({
// //   pageContainer: {
// //     width: "100%",
// //     minHeight: "100vh",
// //     backgroundImage: "linear-gradient(#faf9f2, #faf3f0, #cdd4cc)",
// //     display: "flex",
// //     flexDirection: "column",
// //     justifyContent: "flex-start",
// //     alignItems: "center",
// //   },
// //   container: {
// //     // width: "100%",
// //     // display: "flex",
// //     // flexDirection: "column",
// //     // justifyContent: "center",
// //     // alignItems: "center",
// //     // marginTop: 25,
// //     // marginBottom: 100,

// //     width: "100%",
// //     display: "flex",
// //     flexDirection: "column",
// //     justifyContent: "center",
// //     alignItems: "center",
// //     // marginTop: theme.spacing(10),
// //     marginTop: 25,
// //   },
// //   heading: {
// //     background: "linear-gradient(45deg, #FF1744 30%, #2962FF 90%)",
// //     "-webkit-background-clip": "text",
// //     "-webkit-text-fill-color": "transparent",
// //     fontWeight: "bold",
// //     textAlign: "center",
// //   },
// //   inputTextField: {
// //     width: "80%",
// //     "&&": {
// //       marginBottom: 25,
// //     },
// //   },
// //   alternateLinkText: {
// //     marginTop: 20,
// //   },
// // }));

// // const acceptedFileTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
// // const fileSizeLimitInMB = 100;














// import { useState, useContext, useEffect, useRef } from "react";
// import { Navigate, useNavigate } from "react-router-dom";
// import { Button,   Box, Container, Typography, TextField, Paper,  List,  ListItem,  ListItemText, Chip, InputAdornment, Divider
// } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import { Search, ExpandMore, Clear } from '@mui/icons-material';
// import ClipLoader from "react-spinners/ClipLoader";
// import { toast } from "react-toastify";

// import userContext from "../context/userContext";
// import apiClient from "../api/apiServices";
// import { convertArrOfStringsToString } from "../utils/stringUtils";

// const templateImages = {
//   // TODO: get this dynamically from the backend as well
//   urdu: `/static/Urdu - Template.jpg`,
// };

// // Enhanced Select Component with Search and Suggestions
// const EnhancedSelect = ({ 
//   placeholder, 
//   selectedValue, 
//   setSelectedValue, 
//   allValues, 
//   disabled = false,
//   width = "400px",
//   showSearch = true
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredValues, setFilteredValues] = useState(allValues || []);
//   const containerRef = useRef(null);
//   const searchInputRef = useRef(null);

//   useEffect(() => {
//     if (!allValues) {
//       setFilteredValues([]);
//       return;
//     }

//     let filtered = allValues.filter(value =>
//       value.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     setFilteredValues(filtered);
//   }, [allValues, searchTerm]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (containerRef.current && !containerRef.current.contains(event.target)) {
//         setIsOpen(false);
//         setSearchTerm('');
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   useEffect(() => {
//     if (isOpen && showSearch && searchInputRef.current) {
//       setTimeout(() => {
//         searchInputRef.current?.focus();
//       }, 100);
//     }
//   }, [isOpen, showSearch]);

//   const handleToggle = () => {
//     if (!disabled) {
//       setIsOpen(!isOpen);
//       if (!isOpen) {
//         setSearchTerm('');
//       }
//     }
//   };

//   const handleSelect = (value) => {
//     setSelectedValue(value);
//     setIsOpen(false);
//     setSearchTerm('');
//   };

//   const clearSearch = () => {
//     setSearchTerm('');
//     if (searchInputRef.current) {
//       searchInputRef.current.focus();
//     }
//   };

//   const renderSimpleList = () => {
//     return filteredValues.map((value, index) => (
//       <ListItem
//         key={index}
//         button
//         onClick={() => handleSelect(value)}
//         sx={{
//           '&:hover': { bgcolor: 'primary.50' },
//           borderBottom: '1px solid',
//           borderColor: 'grey.100'
//         }}
//       >
//         <ListItemText 
//           primary={value}
//           sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
//         />
//       </ListItem>
//     ));
//   };

//   return (
//     <Box ref={containerRef} sx={{ position: 'relative', width }}>
//       <TextField
//         fullWidth
//         value={selectedValue || ''}
//         placeholder={placeholder}
//         onClick={handleToggle}
//         disabled={disabled}
//         InputProps={{
//           readOnly: true,
//           endAdornment: (
//             <InputAdornment position="end">
//               <ExpandMore 
//                 sx={{ 
//                   cursor: disabled ? 'default' : 'pointer',
//                   transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//                   transition: 'transform 0.2s ease-in-out',
//                   color: disabled ? 'grey.400' : 'grey.600'
//                 }} 
//               />
//             </InputAdornment>
//           ),
//           sx: {
//             cursor: disabled ? 'default' : 'pointer',
//             '& .MuiOutlinedInput-input': {
//               cursor: disabled ? 'default' : 'pointer'
//             }
//           }
//         }}
//         sx={{
//           '& .MuiOutlinedInput-root': {
//             backgroundColor: disabled ? 'grey.100' : 'white',
//           }
//         }}
//       />
      
//       {isOpen && (
//         <Paper
//           elevation={8}
//           sx={{
//             position: 'absolute',
//             top: '100%',
//             left: 0,
//             right: 0,
//             zIndex: 1300,
//             maxHeight: '320px',
//             overflow: 'hidden',
//             mt: 1,
//             border: '1px solid',
//             borderColor: 'grey.300'
//           }}
//         >
//           {showSearch && (
//             <Box sx={{ p: 2, bgcolor: 'grey.50', borderBottom: '1px solid', borderColor: 'grey.200' }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 placeholder="Search..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 inputRef={searchInputRef}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Search sx={{ color: 'grey.400', fontSize: '1.2rem' }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: searchTerm && (
//                     <InputAdornment position="end">
//                       <Clear 
//                         sx={{ 
//                           color: 'grey.400', 
//                           fontSize: '1rem', 
//                           cursor: 'pointer' 
//                         }}
//                         onClick={clearSearch}
//                       />
//                     </InputAdornment>
//                   )
//                 }}
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     backgroundColor: 'white'
//                   }
//                 }}
//               />
//             </Box>
//           )}
          
//           <List 
//             sx={{ 
//               maxHeight: showSearch ? '240px' : '300px', 
//               overflow: 'auto',
//               p: 0 
//             }}
//           >
//             {filteredValues.length > 0 ? (
//               renderSimpleList()
//             ) : (
//               <ListItem>
//                 <ListItemText 
//                   primary={`No options found${searchTerm ? ` for "${searchTerm}"` : ''}`}
//                   sx={{ 
//                     textAlign: 'center',
//                     '& .MuiListItemText-primary': { 
//                       color: 'grey.500',
//                       fontStyle: 'italic'
//                     }
//                   }}
//                 />
//               </ListItem>
//             )}
//           </List>
//         </Paper>
//       )}
//     </Box>
//   );
// };

// const NewUpload = () => {
//   const classes = useStyles();
//   const navigate = useNavigate();
//   const { user, backendConfig, appSettings } = useContext(userContext);

//   const fileInputRef = useRef();

//   const [filename, setFilename] = useState(null);
//   const [file, setFile] = useState(null);
//   const [filepath, setFilepath] = useState(null);
//   const [fileExtension, setFileExtension] = useState(null);
//   const [fileObjectUrl, setFileObjectUrl] = useState(null);
//   const [isUploading, setIsUploading] = useState(false);

//   const [isLoadingAvailableCredits, setIsLoadingAvailableCredits] = useState(false);
//   const [pagesRemaining, setPagesRemaining] = useState(null);

//   const [availableTextRecognizers, setAvailableTextRecognizers] = useState([]);
//   const [availableTextRecognizersNames, setAvailableTextRecognizersNames] = useState([]);
//   const [selectedTextRecognizerName, setSelectedTextRecognizerName] = useState("");

//   const [availableDocumentParsers, setAvailableDocumentParsers] = useState([]);
//   const [supportedDocumentParsersNames, setSupportedDocumentParsersNames] = useState([]);
//   const [selectedDocumentParserName, setSelectedDocumentParserName] = useState("");

//   const [isTemplateImageLoaded, setIsTemplateImageLoaded] = useState(false);

//   const [processingStatus, setProcessingStatus] = useState("Uploading...");

//   const getAvailableCreditsFromApi = async () => {
//     setIsLoadingAvailableCredits(true);

//     const response = await apiClient.user.getAvailableCredits();
//     if (!response.success) {
//       console.log(response);
//       setIsLoadingAvailableCredits(false);
//       return;
//     }

//     setPagesRemaining(Math.floor(response.result.credits));
//     setIsLoadingAvailableCredits(false);
//   };

//   const handleFileUpload = (event, drop = false) => {
//     let uploadedFile;
//     if (drop) {
//       event.preventDefault();
//       uploadedFile = event.dataTransfer.files[0];
//     } else {
//       uploadedFile = event.target.files[0];
//     }

//     if (!uploadedFile) {
//       return;
//     }

//     if (!acceptedFileTypes.includes(uploadedFile.type)) {
//       toast(`Accepted file types are: ${convertArrOfStringsToString(acceptedFileTypes)}.`);
//       return;
//     }

//     if (uploadedFile.size > fileSizeLimitInMB * 1024 * 1024) {
//       toast(`File cannot be larger than ${fileSizeLimitInMB} MB.`);
//       return;
//     }

//     setFilename(uploadedFile.name);
//     setFileExtension(uploadedFile.name.split(".").pop());
//     setFilepath(uploadedFile);
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const fileData = e.target.result;
//       setFileObjectUrl(URL.createObjectURL(uploadedFile));
//       setFile(fileData);
//     };
//     reader.readAsDataURL(uploadedFile);
//   };

//   const goButtonOnClick = async () => {
//     setIsUploading(true);

//     const selectedTextRecognizer = availableTextRecognizers.find(
//       (textRecognizer) => textRecognizer.displayName === selectedTextRecognizerName
//     );
//     const selectedDocumentParser = availableDocumentParsers.find(
//       (documentParser) => documentParser.displayName === selectedDocumentParserName
//     );

//     const response = await apiClient.uploads.addNew(
//       filepath,
//       selectedDocumentParser.modelId,
//       "no_postprocessor",
//       selectedTextRecognizer.modelId
//     );

//     if (!response.success) {
//       console.log(response);
//       toast(response.error.message);
//       setIsUploading(false);
//       return;
//     }

//     setPagesRemaining(pagesRemaining - 1);
//     setIsUploading(false);

//     if (appSettings.redirectToHistoryPageOnNewUploadSubmit) {
//       navigate("/history/1");
//     } else {
//       toast("Queued for processing. Please check the history page for status.");
//     }
//   };

//   useEffect(() => {
//     document.title = "Upload New";

//     getAvailableCreditsFromApi();
//   }, []);

//   useEffect(() => {
//     if (!backendConfig?.text_recognizers || !backendConfig?.document_parsers) {
//       return;
//     }

//     const textRecognizersNames = backendConfig.text_recognizers.map((textRecognizer) => textRecognizer.displayName);

//     setAvailableTextRecognizers(backendConfig.text_recognizers);
//     setAvailableTextRecognizersNames(textRecognizersNames);
//     setAvailableDocumentParsers(backendConfig.document_parsers);
//   }, [backendConfig]);

//   useEffect(() => {
//     if (!selectedTextRecognizerName) {
//       setSupportedDocumentParsersNames([]);
//       return;
//     }

//     const selectedTextRecognizer = availableTextRecognizers.find(
//       (textRecognizer) => textRecognizer.displayName === selectedTextRecognizerName
//     );

//     const requiredDetectionLevel = selectedTextRecognizer.detectionLevel[0];
//     const documentParsersWithRequiredDetectionLevel = availableDocumentParsers.filter(
//       (documentParser) => documentParser.detectionLevel.includes(requiredDetectionLevel)
//     );
//     const documentParsersWithRequiredDetectionLevelNames = documentParsersWithRequiredDetectionLevel.map(
//       (documentParser) => documentParser.displayName
//     );

//     setSupportedDocumentParsersNames(documentParsersWithRequiredDetectionLevelNames);

//     // TODO: update template image
//   }, [selectedTextRecognizerName]);

//   if (user === null) {
//     return navigate("/auth/login");
//   }

//   if (!user.canCompute) {
//     return (
//       <div className={classes.pageContainer}>
//         <Container maxWidth="lg" className={classes.container}>
//           <Typography variant="h5" color="error">
//             You do not have compute permission. Please contact an admin for more details.
//           </Typography>
//         </Container>
//       </div>
//     );
//   }

//   return (
//     <div className={classes.pageContainer}>
//       <Box width="100%" display="flex" flexDirection="column" justifyContent="flex-start" alignItems="center" mb={2} mt={2}>
//           <Typography className={classes.heading} variant="h3" style={{ fontWeight: "bold", textAlign: "center" }}>
//             Upload a New File for OCR
//           </Typography>
//         </Box>
//       <div className={classes.container}>
//         <Box mb={2} ml={20}>
//           {/* {file ? (
//             fileExtension === "pdf" ? (
//               <object
//                 data={file}
//                 type="application/pdf"
//                 width={400}
//                 height={400}
//                 // onDrop={(e) => handleFileUpload(e, true)}
//               >
//                 <Button
//                   color="primary"
//                   variant="outlined"
//                   sx={{ minWidth: 300 }}
//                   onClick={() => window.open(fileObjectUrl, "_blank")}
//                 >
//                   {`File Loaded: ${filename}`}
//                 </Button>
//               </object>
//             ) : (
//               <img
//                 style={{
//                   display: "block",
//                   maxWidth: "50vw",
//                   maxHeight: "50vh",
//                   width: "auto",
//                   height: "auto",
//                   marginBottom: "5vh",
//                   border: "1px solid black",
//                 }}
//                 src={file}
//                 alt="uploaded image"
//                 onDrop={(e) => handleFileUpload(e, true)}
//                 onDragOver={(e) => e.preventDefault()}
//               />
//             )
//           ) : (
//             <>
//               <div
//                 onDrop={(e) => handleFileUpload(e, true)}
//                 onDragOver={(e) => e.preventDefault()}
//                 style={{
//                   width: "50vw",
//                   height: "50vh",
//                   border: "1px",
//                   backgroundImage: "linear-gradient(#e6fafd)",
//                   borderRadius: 25,
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   marginBottom: "2vh",
//                 }}
//               >
//                 Drag and drop file here
//               </div>
//               <Box display="flex" justifyContent="center" alignItems="center">
//                 <input
//                   id="image-upload-input"
//                   type="file"
//                   accept=".jpg,.jpeg,.pdf"
//                   onChange={handleFileUpload}
//                   style={{ display: "none" }}
//                   ref={fileInputRef}
//                 />
//                 <label
//                   for="image-upload-input"
//                   style={{
//                     backgroundImage: "linear-gradient(#e6fafd,#8cdcf3)",
//                     border: "1px ",
//                     padding: 10,
//                     paddingLeft:45,
//                     paddingRight:45,
//                     borderRadius: 5,
//                     marginBottom: 15,
//                     cursor: "pointer",
//                   }}
//                 >
//                   {isTemplateImageLoaded ? "Choose Another File" : filename ? filename : "Choose File"}
//                 </label>
//               </Box>
              
//             </>
//           )} */}
//           {file ? (
//             <>
//               {fileExtension === "pdf" ? (
//                 <object
//                   data={file}
//                   type="application/pdf"
//                   width={400}
//                   height={400}
//                 >
//                   <Button
//                     color="primary"
//                     variant="outlined"
//                     sx={{ minWidth: 500 }}
//                     onClick={() => window.open(fileObjectUrl, "_blank")}
//                   >
//                     {`File Loaded: ${filename}`}
//                   </Button>
//                 </object>
//               ) : (
//                 <img
//                   style={{
//                     display: "block",
//                     maxWidth: "1200px",
//                     maxHeight:"1000px",
//                     width: "auto",
//                     height: "auto",
//                     marginBottom: "5vh",
//                     border: "1px solid black",
//                   }}
//                   src={file}
//                   alt="uploaded image"
//                   onDrop={(e) => handleFileUpload(e, true)}
//                   onDragOver={(e) => e.preventDefault()}
//                 />
//               )}
//               <Box display="flex" justifyContent="center" alignItems="center">
//                 <input
//                   id="image-upload-input"
//                   type="file"
//                   accept="image/jpeg,image/png,image/jpg,application/pdf"
//                   onChange={handleFileUpload}
//                   style={{ display: "none" }}
//                   ref={fileInputRef}
//                 />
//                 <label
//                   htmlFor="image-upload-input"
//                   style={{
//                     backgroundImage: "linear-gradient(#e6fafd,#8cdcf3)",
//                     border: "1px ",
//                     padding: 10,
//                     paddingLeft:45,
//                     paddingRight:45,
//                     borderRadius: 5,
//                     marginBottom: 15,
//                     cursor: "pointer",
//                   }}
//                 >
//                   Choose Different File
//                 </label>
//               </Box>
//             </>
//           ) : (
//             <>
//               <div
//                 onDrop={(e) => handleFileUpload(e, true)}
//                 onDragOver={(e) => e.preventDefault()}
//                 style={{
//                   width: "50vw",
//                   height: "50vh",
//                   border: "1px",
//                   backgroundImage: "linear-gradient(#e6fafd)",
//                   borderRadius: 25,
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   marginBottom: "2vh",
//                 }}
//               >
//                 Drag and drop file here
//               </div>
//               <Box display="flex" justifyContent="center" alignItems="center">
//                 <input
//                   id="image-upload-input"
//                   type="file"
//                   accept="image/jpeg,image/png,image/jpg,application/pdf"
//                   onChange={handleFileUpload}
//                   style={{ display: "none" }}
//                   ref={fileInputRef}
//                 />
//                 <label
//                   htmlFor="image-upload-input"
//                   style={{
//                     backgroundImage: "linear-gradient(#e6fafd,#8cdcf3)",
//                     border: "1px ",
//                     padding: 10,
//                     paddingLeft:45,
//                     paddingRight:45,
//                     borderRadius: 5,
//                     marginBottom: 15,
//                     cursor: "pointer",
//                   }}
//                 >
//                   {isTemplateImageLoaded ? "Choose Another File" : filename ? filename : "Choose File"}
//                 </label>
//               </Box>
//             </>
//           )}
//         </Box>

//         <Box width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2} mb={2} mr={4}>
//           <Box width="400px" sx={{ backgroundColor: '#e3f2fd' }}>
//             <EnhancedSelect
//               placeholder="Select Language"
//               selectedValue={selectedTextRecognizerName}
//               setSelectedValue={(newValue) => {
//                 setSelectedTextRecognizerName(newValue);
//               }}
//               allValues={availableTextRecognizersNames}
//               showSearch={true}
//               width="400px"
//             />
//           </Box>

//           <Box width="400px" sx={{ backgroundColor: '#e3f2fd' }}>
//             <EnhancedSelect
//               placeholder="Select Parser"
//               selectedValue={selectedDocumentParserName}
//               setSelectedValue={(newValue) => {
//                 setSelectedDocumentParserName(newValue);
//               }}
//               allValues={supportedDocumentParsersNames}
//               disabled={!selectedTextRecognizerName}
//               showSearch={false}
//               width="400px"
//             />
//           </Box>
          
//           <Box mb={2}>
//           {isUploading ? (
//             <ClipLoader color={"#e3f2fd"} loading={true} size={35} />
//           ) : (
//             <Button
//               variant="contained"
//               size="large"
//               disabled={file === null || !selectedTextRecognizerName || !selectedDocumentParserName}
//               onClick={goButtonOnClick}
//             >
//               Start OCR !
//             </Button>
//           )}
//         </Box>
//         </Box>
//       </div>
      
//       <Box mb={2} mt={10}>
//       {isUploading ? (
//        <Typography variant="h6">{processingStatus}</Typography>
//        ) : !isLoadingAvailableCredits && pagesRemaining ? (
//        <Typography variant="h6" color={pagesRemaining <= 10 ? "error" : "primary"}>
//        {`You can OCR ${pagesRemaining} more ${pagesRemaining === 1 ? "page" : "pages"}.`}
//        </Typography>
//        ) : !isLoadingAvailableCredits && pagesRemaining === null ? (
//        <Typography variant="h6" color="error">
//         Unable to retrieve the available pages quota from the server.
//        </Typography>
//        ) : null}
//         </Box>
//     </div>
//   );
// };

// export default NewUpload;

// const useStyles = makeStyles((theme) => ({
//   pageContainer: {
//     width: "100%",
//     minHeight: "100vh",
//     backgroundImage: "linear-gradient(#faf9f2,#f0fdfa))",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "flex-start",
//     alignItems: "center",
//   },
//   container: {
//     width: "100%",
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     marginTop: 25,
//   },
//   heading: {
//     background: "linear-gradient(45deg,rgb(0, 0, 0) 30%,rgb(0, 0, 0) 90%)",
//     "-webkit-background-clip": "text",
//     "-webkit-text-fill-color": "transparent",
//     fontWeight: "bold",
//     textAlign: "center",
//   },
//   inputTextField: {
//     width: "80%",
//     "&&": {
//       marginBottom: 25,
//     },
//   },
//   alternateLinkText: {
//     marginTop: 20,
//   },
// }));

// const acceptedFileTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
// const fileSizeLimitInMB = 100;



import { useState, useContext, useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { 
  Button, Box, Container, Typography, TextField, Paper, List, ListItem, ListItemText, 
  Chip, InputAdornment, Divider, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions,
  IconButton, Fade, Zoom
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { 
  Search, ExpandMore, Clear, Language, CheckCircle, RadioButtonUnchecked,
  Close, Translate, PublicOutlined
} from '@mui/icons-material';
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import userContext from "../context/userContext";
import apiClient from "../api/apiServices";


// Enhanced Select Component with Search and Suggestions (keeping original for parser)
const EnhancedSelect = ({ 
  placeholder, 
  selectedValue, 
  setSelectedValue, 
  allValues, 
  disabled = false,
  width = "400px",
  showSearch = true
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredValues, setFilteredValues] = useState(allValues || []);
  const containerRef = useRef(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    if (!allValues) {
      setFilteredValues([]);
      return;
    }

    let filtered = allValues.filter(value =>
      value.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredValues(filtered);
  }, [allValues, searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && showSearch && searchInputRef.current) {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    }
  }, [isOpen, showSearch]);

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
      if (!isOpen) {
        setSearchTerm('');
      }
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setIsOpen(false);
    setSearchTerm('');
  };

  const clearSearch = () => {
    setSearchTerm('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  const renderSimpleList = () => {
    return filteredValues.map((value, index) => (
      <ListItem
        key={index}
        button
        onClick={() => handleSelect(value)}
        sx={{
          '&:hover': { bgcolor: 'primary.50' },
          borderBottom: '1px solid',
          borderColor: 'grey.100'
        }}
      >
        <ListItemText 
          primary={value}
          sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
        />
      </ListItem>
    ));
  };

  return (
    <Box ref={containerRef} sx={{ position: 'relative', width }}>
      <TextField
        fullWidth
        value={selectedValue || ''}
        placeholder={placeholder}
        onClick={handleToggle}
        disabled={disabled}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ExpandMore 
                sx={{ 
                  cursor: disabled ? 'default' : 'pointer',
                  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease-in-out',
                  color: disabled ? 'grey.400' : 'grey.600'
                }} 
              />
            </InputAdornment>
          ),
          sx: {
            cursor: disabled ? 'default' : 'pointer',
            '& .MuiOutlinedInput-input': {
              cursor: disabled ? 'default' : 'pointer'
            }
          }
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: disabled ? 'grey.100' : 'white',
          }
        }}
      />
      
      {isOpen && (
        <Paper
          elevation={8}
          sx={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1300,
            maxHeight: '320px',
            overflow: 'hidden',
            mt: 1,
            border: '1px solid',
            borderColor: 'grey.300'
          }}
        >
          {showSearch && (
            <Box sx={{ p: 2, bgcolor: 'grey.50', borderBottom: '1px solid', borderColor: 'grey.200' }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                inputRef={searchInputRef}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: 'grey.400', fontSize: '1.2rem' }} />
                    </InputAdornment>
                  ),
                  endAdornment: searchTerm && (
                    <InputAdornment position="end">
                      <Clear 
                        sx={{ 
                          color: 'grey.400', 
                          fontSize: '1rem', 
                          cursor: 'pointer' 
                        }}
                        onClick={clearSearch}
                      />
                    </InputAdornment>
                  )
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white'
                  }
                }}
              />
            </Box>
          )}
          
          <List 
            sx={{ 
              maxHeight: showSearch ? '240px' : '300px', 
              overflow: 'auto',
              p: 0 
            }}
          >
            {filteredValues.length > 0 ? (
              renderSimpleList()
            ) : (
              <ListItem>
                <ListItemText 
                  primary={`No options found${searchTerm ? ` for "${searchTerm}"` : ''}`}
                  sx={{ 
                    textAlign: 'center',
                    '& .MuiListItemText-primary': { 
                      color: 'grey.500',
                      fontStyle: 'italic'
                    }
                  }}
                />
              </ListItem>
            )}
          </List>
        </Paper>
      )}
    </Box>
  );
};

// New Language Table Selector Component
const LanguageTableSelector = ({ 
  selectedValue, 
  setSelectedValue, 
  availableLanguages = []
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredLanguages, setFilteredLanguages] = useState(availableLanguages);

  useEffect(() => {
    const filtered = availableLanguages.filter(lang =>
      lang.displayName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredLanguages(filtered);
  }, [availableLanguages, searchTerm]);

  const handleLanguageSelect = (language) => {
    setSelectedValue(language.displayName);
    setIsDialogOpen(false);
    setSearchTerm('');
  };




  return (
    <>
      <TextField
        fullWidth
        value={selectedValue || ''}
        placeholder="Choose Language for OCR"
        onClick={() => setIsDialogOpen(true)}
        InputProps={{
          readOnly: true,
          startAdornment: (
            <InputAdornment position="start">
              <Language sx={{ color: 'primary.main' }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Button
                variant="contained"
                size="small"
                sx={{ 
                  mr: 1,
                  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #1976D2 30%, #0288D1 90%)',
                  }
                }}
              >
                Browse All Languages
              </Button>
            </InputAdornment>
          ),
          sx: {
            cursor: 'pointer',
            '& .MuiOutlinedInput-input': {
              cursor: 'pointer'
            }
          }
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            '&:hover': {
              backgroundColor: '#f8f9fa'
            }
          }
        }}
      />

      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: 'linear-gradient(135deg, #0c609c 0%, #0c609c 100%)',
            color: 'white'
          }
        }}
        TransitionComponent={Zoom}
        transitionDuration={300}
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          pb: 1,
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)'
        }}>
          <Box display="flex" alignItems="center" gap={2}>
            <PublicOutlined sx={{ fontSize: 28 }} />
            <Typography variant="h5" fontWeight="bold">
              Select OCR Language
            </Typography>
          </Box>
          <IconButton 
            onClick={() => setIsDialogOpen(false)}
            sx={{ color: 'white' }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ p: 3, background: 'rgba(255, 255, 255, 0.05)' }}>
            <TextField
              fullWidth
              placeholder="Search languages..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: 'rgba(255, 255, 255, 0.7)' }} />
                  </InputAdornment>
                ),
                sx: {
                  color: 'white',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(255, 255, 255, 0.3)'
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(255, 255, 255, 0.5)'
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'white'
                  }
                }
              }}
              sx={{
                '& .MuiInputBase-input': {
                  color: 'white',
                  '&::placeholder': {
                    color: 'rgba(255, 255, 255, 0.7)'
                  }
                }
              }}
            />
            <Typography variant="body2" sx={{ mt: 2, opacity: 0.8 }}>
              {filteredLanguages.length} language{filteredLanguages.length !== 1 ? 's' : ''} available
            </Typography>
          </Box>

          <TableContainer sx={{ maxHeight: 450, background: 'rgba(255, 255, 255, 0.95)' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', background: 'rgba(102, 126, 234, 0.1)' }}>
                  #
                </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', background: 'rgba(102, 126, 234, 0.1)' }}>
                    Select
                  </TableCell>
                  {/* <TableCell sx={{ fontWeight: 'bold', background: 'rgba(102, 126, 234, 0.1)' }}>
                    Flag
                  </TableCell> */}
                  <TableCell sx={{ fontWeight: 'bold', background: 'rgba(102, 126, 234, 0.1)' }}>
                    Language 
                  </TableCell>
                  {/* <TableCell sx={{ fontWeight: 'bold', background: 'rgba(102, 126, 234, 0.1)' }}>
                    Script Family
                  </TableCell> */}
                  {/* <TableCell sx={{ fontWeight: 'bold', background: 'rgba(102, 126, 234, 0.1)' }}>
                    Detection Level
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredLanguages.map((language, index) => (
                  <TableRow
                    key={index}
                    onClick={() => handleLanguageSelect(language)}
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: 'rgba(102, 126, 234, 0.1)',
                        transform: 'scale(1.01)',
                        transition: 'all 0.2s ease-in-out'
                      },
                      '&:nth-of-type(even)': {
                        backgroundColor: 'rgba(0, 0, 0, 0.02)'
                      }
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {selectedValue === language.displayName ? (
                        <CheckCircle sx={{ color: 'success.main' }} />
                      ) : (
                        <RadioButtonUnchecked sx={{ color: 'grey.400' }} />
                      )}
                    </TableCell>
                    {/* <TableCell>
                      <Typography variant="h6" component="span">
                        {getLanguageFlag(language.modelId)}
                      </Typography>
                    </TableCell> */}
                    <TableCell>
                      <Typography variant="subtitle1" fontWeight="medium" color="text.primary">
                        {language.displayName}
                      </Typography>
                      {/* <Typography variant="caption" color="text.secondary">
                        Model ID: {language.modelId}
                      </Typography> */}
                    </TableCell>
                    {/* <TableCell>
                      <Chip
                        label={getLanguageCategory(language.displayName)}
                        size="small"
                        sx={{
                          backgroundColor: 'primary.50',
                          color: 'primary.main',
                          fontWeight: 'medium'
                        }}
                      />
                    </TableCell> */}
                    {/* <TableCell>
                      <Chip
                        label={language.detectionLevel[0]}
                        size="small"
                        variant="outlined"
                        sx={{
                          borderColor: language.detectionLevel[0] === 'char' ? 'warning.main' : 'info.main',
                          color: language.detectionLevel[0] === 'char' ? 'warning.main' : 'info.main'
                        }}
                      />
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions sx={{ 
          p: 3, 
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)' 
        }}>
          <Button 
            onClick={() => setIsDialogOpen(false)} 
            variant="outlined"
            sx={{ 
              color: 'white', 
              borderColor: 'rgba(255, 255, 255, 0.5)',
              '&:hover': {
                borderColor: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={() => setIsDialogOpen(false)}
            variant="contained"
            disabled={!selectedValue}
            sx={{
              background: selectedValue 
                ? 'linear-gradient(45deg, #4CAF50 30%, #45A049 90%)'
                : 'grey.300',
              '&:hover': {
                background: selectedValue 
                  ? 'linear-gradient(45deg, #45A049 30%, #388E3C 90%)'
                  : 'grey.300'
              }
            }}
          >
            Confirm Selection
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const NewUpload = () => {
  const navigate = useNavigate();
  // Using mock data - replace with actual useContext in your implementation
    const { backendConfig , user, appSettings } = useContext(userContext);
  // const { user, appSettings } = mockUserContext;

  const fileInputRef = useRef();

  const [filename, setFilename] = useState(null);
  const [file, setFile] = useState(null);
  const [filepath, setFilepath] = useState(null);
  const [fileExtension, setFileExtension] = useState(null);
  const [fileObjectUrl, setFileObjectUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const [isLoadingAvailableCredits, setIsLoadingAvailableCredits] = useState(false);
  const [pagesRemaining, setPagesRemaining] = useState(null);

  const [availableTextRecognizers, setAvailableTextRecognizers] = useState([]);
  const [availableTextRecognizersNames, setAvailableTextRecognizersNames] = useState([]);
  const [selectedTextRecognizerName, setSelectedTextRecognizerName] = useState("");

  const [availableDocumentParsers, setAvailableDocumentParsers] = useState([]);
  const [supportedDocumentParsersNames, setSupportedDocumentParsersNames] = useState([]);
  const [selectedDocumentParserName, setSelectedDocumentParserName] = useState("");

  const [isTemplateImageLoaded, setIsTemplateImageLoaded] = useState(false);
  const [processingStatus, setProcessingStatus] = useState("Uploading...");

  const acceptedFileTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
  const fileSizeLimitInMB = 100;


  const getAvailableCreditsFromApi = async () => {
    setIsLoadingAvailableCredits(true);

    const response = await apiClient.user.getAvailableCredits();
    if (!response.success) {
      console.log(response);
      setIsLoadingAvailableCredits(false);
      return;
    }

    setPagesRemaining(Math.floor(response.result.credits));
    setIsLoadingAvailableCredits(false);
  };

  const handleFileUpload = (event, drop = false) => {
    let uploadedFile;
    if (drop) {
      event.preventDefault();
      uploadedFile = event.dataTransfer.files[0];
    } else {
      uploadedFile = event.target.files[0];
    }

    if (!uploadedFile) return;

    if (!acceptedFileTypes.includes(uploadedFile.type)) {
      alert(`Accepted file types are: ${acceptedFileTypes.join(', ')}`);
      return;
    }

    if (uploadedFile.size > fileSizeLimitInMB * 1024 * 1024) {
      alert(`File cannot be larger than ${fileSizeLimitInMB} MB.`);
      return;
    }

    setFilename(uploadedFile.name);
    setFileExtension(uploadedFile.name.split(".").pop());
    setFilepath(uploadedFile);
    const reader = new FileReader();
    reader.onload = (e) => {
      const fileData = e.target.result;
      setFileObjectUrl(URL.createObjectURL(uploadedFile));
      setFile(fileData);
    };
    reader.readAsDataURL(uploadedFile);
  };

  const goButtonOnClick = async () => {
    setIsUploading(true);
    
    const selectedTextRecognizer = availableTextRecognizers.find(
      (textRecognizer) => textRecognizer.displayName === selectedTextRecognizerName
    );
    const selectedDocumentParser = availableDocumentParsers.find(
      (documentParser) => documentParser.displayName === selectedDocumentParserName
    );
    
    const response = await apiClient.uploads.addNew(
      filepath,
      selectedDocumentParser.modelId,
      "no_postprocessor",
      selectedTextRecognizer.modelId
    );
  
    if (!response.success) {
      console.log(response);
      toast(response.error.message);
      setIsUploading(false);
      return;
    }

    setPagesRemaining(pagesRemaining - 1);
    setIsUploading(false);

    if (appSettings.redirectToHistoryPageOnNewUploadSubmit) {
      navigate("/history/1");
    } else {
      toast("Queued for processing. Please check the history page for status.");
    }

    // // Mock API call
    // setTimeout(() => {
    //   setPagesRemaining(pagesRemaining - 1);
    //   setIsUploading(false);
    //   alert("Queued for processing. Please check the history page for status.");
    // }, 2000);
  };

useEffect(() => {
    document.title = "Upload New";

    getAvailableCreditsFromApi();
  }, []);
   

  useEffect(() => {
    if (!backendConfig?.text_recognizers || !backendConfig?.document_parsers) {
      return;
    }

    const textRecognizersNames = backendConfig.text_recognizers.map((textRecognizer) => textRecognizer.displayName);

    setAvailableTextRecognizers(backendConfig.text_recognizers);
    setAvailableTextRecognizersNames(textRecognizersNames);
    setAvailableDocumentParsers(backendConfig.document_parsers);
  }, [backendConfig]);

  useEffect(() => {
    if (!selectedTextRecognizerName) {
      setSupportedDocumentParsersNames([]);
      return;
    }

    const selectedTextRecognizer = availableTextRecognizers.find(
      (textRecognizer) => textRecognizer.displayName === selectedTextRecognizerName
    );

    const requiredDetectionLevel = selectedTextRecognizer.detectionLevel[0];
    const documentParsersWithRequiredDetectionLevel = availableDocumentParsers.filter(
      (documentParser) => documentParser.detectionLevel.includes(requiredDetectionLevel)
    );
    const documentParsersWithRequiredDetectionLevelNames = documentParsersWithRequiredDetectionLevel.map(
      (documentParser) => documentParser.displayName
    );

    setSupportedDocumentParsersNames(documentParsersWithRequiredDetectionLevelNames);
    // TODO: update template image
  }, [selectedTextRecognizerName]);

  if (user === null) {
    return navigate("/auth/login");
  }

  if (!user.canCompute) {
    return (
      <Box sx={{ 
        width: "100%", 
        minHeight: "100vh", 
        background: "linear-gradient(135deg, #faf9f2 0%, #f0fdfa 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center" 
      }}>
        <Container maxWidth="lg">
          <Typography variant="h5" color="error" textAlign="center">
            You do not have compute permission. Please contact an admin for more details.
          </Typography>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      width: "100%", 
      minHeight: "100vh", 
      background: "linear-gradient(135deg, #faf9f2 0%, #f0fdfa 100%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      pt: 3
    }}>
      <Box width="100%" display="flex" flexDirection="column" justifyContent="flex-start" alignItems="center" mb={4}>
        <Typography 
          variant="h3" 
          sx={{ 
            fontWeight: "bold", 
            textAlign: "center",
            background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 1
          }}
        >
          Upload a New File for OCR
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" textAlign="center">
          Support for {backendConfig?.text_recognizers?.length || 30}+ languages with advanced OCR technology
        </Typography>
      </Box>

      <Box display="flex" flexDirection="row" alignItems="flex-start" gap={4} maxWidth="1200px" width="100%">
        {/* File Upload Section */}
        <Box flex={1} display="flex" flexDirection="column" alignItems="center">
          {file ? (
            <>
              {fileExtension === "pdf" ? (
                <object
                  data={file}
                  type="application/pdf"
                  width={400}
                  height={400}
                >
                  <Button
                    color="primary"
                    variant="outlined"
                    sx={{ minWidth: 500 }}
                    onClick={() => window.open(fileObjectUrl, "_blank")}
                  >
                    {`File Loaded: ${filename}`}
                  </Button>
                </object>
              ) : (
                <img
                  style={{
                    display: "block",
                    maxWidth: "600px",
                    maxHeight: "500px",
                    width: "auto",
                    height: "auto",
                    marginBottom: "2rem",
                    border: "2px solid #e0e0e0",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)"
                  }}
                  src={file}
                  alt="uploaded image"
                  onDrop={(e) => handleFileUpload(e, true)}
                  onDragOver={(e) => e.preventDefault()}
                />
              )}
              <Box display="flex" justifyContent="center" alignItems="center">
                <input
                  id="image-upload-input"
                  type="file"
                  accept="image/jpeg,image/png,image/jpg,application/pdf"
                  onChange={handleFileUpload}
                  style={{ display: "none" }}
                  ref={fileInputRef}
                />
                <label
                  htmlFor="image-upload-input"
                  style={{
                    background: "linear-gradient(45deg, #e6fafd 0%, #8cdcf3 100%)",
                    border: "none",
                    padding: "12px 32px",
                    borderRadius: "8px",
                    marginBottom: "15px",
                    cursor: "pointer",
                    fontWeight: "500",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease"
                  }}
                >
                  Choose Different File
                </label>
              </Box>
            </>
          ) : (
            <>
              <div
                onDrop={(e) => handleFileUpload(e, true)}
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "600px",
                  height: "400px",
                  border: "3px dashed #2196F3",
                  background: "linear-gradient(135deg, #e6fafd 0%, #f0f9ff 100%)",
                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "2rem",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
                }}
              >
                <Box textAlign="center">
                  <Typography variant="h6" color="primary" gutterBottom>
                    📁 Drag and drop file here
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    or click below to browse
                  </Typography>
                </Box>
              </div>
              <Box display="flex" justifyContent="center" alignItems="center">
                <input
                  id="image-upload-input"
                  type="file"
                  accept="image/jpeg,image/png,image/jpg,application/pdf"
                  onChange={handleFileUpload}
                  style={{ display: "none" }}
                  ref={fileInputRef}
                />
                <label
                  htmlFor="image-upload-input"
                  style={{
                    background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
                    border: "none",
                    padding: "14px 40px",
                    borderRadius: "8px",
                    marginBottom: "15px",
                    cursor: "pointer",
                    color: "white",
                    fontWeight: "600",
                    fontSize: "16px",
                    boxShadow: "0 4px 15px rgba(33, 150, 243, 0.3)",
                    transition: "all 0.3s ease"
                  }}
                >
                  {filename ? filename : "Choose File"}
                </label>
              </Box>
            </>
          )}
        </Box>

        {/* Settings Section */}
        <Box flex={1} display="flex" flexDirection="column" gap={3} pt={2}>
          <Paper 
            elevation={3} 
            sx={{ 
              p: 3, 
              borderRadius: 3,
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
              <Translate color="primary" />
              OCR Configuration
            </Typography>

            {/* Language Selector */}
            <Box mb={3}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Language Selection
              </Typography>
              <LanguageTableSelector
                selectedValue={selectedTextRecognizerName}
                setSelectedValue={setSelectedTextRecognizerName}
                availableLanguages={availableTextRecognizers}
              />
            </Box>

            {/* Parser Selector */}
            <Box mb={3}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Document Parser
              </Typography>
              <EnhancedSelect
                placeholder="Select Document Parser"
                selectedValue={selectedDocumentParserName}
                setSelectedValue={setSelectedDocumentParserName}
                allValues={supportedDocumentParsersNames}
                disabled={!selectedTextRecognizerName}
                showSearch={false}
                width="100%"
              />
            </Box>

            {/* Action Button */}
            <Box display="flex" justifyContent="center" mt={4}>
              {isUploading ? (
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                  <ClipLoader color={"#2196F3"} loading={true} size={35} />
                  <Typography variant="body2" color="text.secondary">
                    {processingStatus}
                  </Typography>
                </Box>
              ) : (
                <Button
                  variant="contained"
                  size="large"
                  disabled={file === null || !selectedTextRecognizerName || !selectedDocumentParserName}
                  onClick={goButtonOnClick}
                  sx={{
                    px: 6,
                    py: 2,
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    borderRadius: 2,
                    background: 'linear-gradient(45deg, #4CAF50 30%, #45A049 90%)',
                    boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(45deg, #45A049 30%, #388E3C 90%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 20px rgba(76, 175, 80, 0.4)'
                    },
                    '&:disabled': {
                      background: 'linear-gradient(45deg, #bdbdbd 30%, #9e9e9e 90%)',
                      boxShadow: 'none'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  🚀 Start OCR Processing
                </Button>
              )}
            </Box>
          </Paper>

          {/* Credits Info */}
          <Paper 
            elevation={2} 
            sx={{ 
              p: 2, 
              borderRadius: 2,
              background: pagesRemaining <= 10 
                ? 'linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)'
                : 'linear-gradient(135deg, #e8f5e8 0%, #f1f8e9 100%)',
              border: pagesRemaining <= 10 ? '1px solid #f8bbd9' : '1px solid #c8e6c9'
            }}
          >
            {isUploading ? (
              <Typography variant="body1" textAlign="center" color="text.secondary">
                {processingStatus}
              </Typography>
            ) : !isLoadingAvailableCredits && pagesRemaining !== null ? (
              <Box textAlign="center">
                <Typography 
                  variant="h6" 
                  color={pagesRemaining <= 10 ? "error.main" : "success.main"}
                  fontWeight="bold"
                >
                  📄 {pagesRemaining} pages remaining
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={0.5}>
                  You can OCR {pagesRemaining} more {pagesRemaining === 1 ? "page" : "pages"}
                </Typography>
              </Box>
            ) : !isLoadingAvailableCredits && pagesRemaining === null ? (
              <Typography variant="body1" color="error" textAlign="center">
                ⚠️ Unable to retrieve available pages quota from server
              </Typography>
            ) : (
              <Box display="flex" justifyContent="center">
                <ClipLoader color={"#666"} loading={true} size={20} />
              </Box>
            )}
          </Paper>
        </Box>
      </Box>

      {/* Features Showcase */}
      <Box mt={6} mb={4} maxWidth="1200px" width="100%">
        <Typography variant="h6" textAlign="center" gutterBottom color="text.secondary">
          🌟 Why Choose Our OCR?
        </Typography>
        <Box display="flex" justifyContent="center" gap={4} mt={3}>
          <Chip 
            label="20+ Languages" 
            variant="outlined" 
            color="primary" 
            sx={{ fontSize: '1rem', py: 2, px: 1 }}
          />
          <Chip 
            label="High Accuracy" 
            variant="outlined" 
            color="success" 
            sx={{ fontSize: '1rem', py: 2, px: 1 }}
          />
          <Chip 
            label="Fast Processing" 
            variant="outlined" 
            color="info" 
            sx={{ fontSize: '1rem', py: 2, px: 1 }}
          />
          <Chip 
            label="Multiple Formats" 
            variant="outlined" 
            color="warning" 
            sx={{ fontSize: '1rem', py: 2, px: 1 }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default NewUpload;